/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAliasResponse
 */
export interface CreateAliasResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAliasResponse
     */
    alias?: string;
}

/**
 * Check if a given object implements the CreateAliasResponse interface.
 */
export function instanceOfCreateAliasResponse(value: object): boolean {
    return true;
}

export function CreateAliasResponseFromJSON(json: any): CreateAliasResponse {
    return CreateAliasResponseFromJSONTyped(json, false);
}

export function CreateAliasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAliasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'alias': json['alias'] == null ? undefined : json['alias'],
    };
}

export function CreateAliasResponseToJSON(value?: CreateAliasResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alias': value['alias'],
    };
}

